import React, { Component } from 'react';
import TracksSidePanel from './tracks/TracksSidePanel.js';
import TracksShowButton from './tracks/TracksShowButton.js';
import {getIsSelected} from './selectors.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import {getVolume} from 'utils/getVolume.js';
import {EFFECTS} from 'constants/arrangement-modes.js';
import AutomationTypeDropdown from './AutomationTypeDropdown.js';
import { connect } from "react-redux";
import ReactBootstrapSlider from 'react-bootstrap-slider';
import VolumeBox from 'components/instruments/VolumeBox.js';
import Colors from 'components/Colors.js';
import {
    setSelectedArrangementEvents,
    setArrangementBottomMode,
    setArrangementSelectedRows,
} from 'actions/index.js';

const colors = new Colors();
const NAMES = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
const MAX_NAME_LENGTH = 18;

function SubSequenceSidePanel(props) {
    const onChangeVolume = (volume) => {
        props.subSequence.fade = volume;
    };

    const onClickMute = () => {
        props.subSequence.mute = !props.muted;
    };

    const stopPropagation = (e) => {
        e.stopPropagation();
    };

    const toggleEnabled = () => {
        props.subSequence.tracks[0].toggleEnabled();
    };

    const selectRow = (e) => {
        e.stopPropagation();
        props.setSelectedRows([props.subSequence.id]);
        props.sequencerEngine.switchToSubSequence(props.subSequence.id, false);
        /*
        if (props.subSequence.tracks.length === 1) {
            // props.subSequence.tracks[0].updateSteps();
            //props.setArrangementMode(EFFECTS);
        } else {
            props.setArrangementMode(undefined);
        }
        */

        // props.clearSelectedArrangementEvents();
    };

    let className = "pattern-info sub-sequence";
    if (props.isSelected) {
        className += ' selected';
    }

    let name = props.subSequence.tracks.length === 1 ?
        props.subSequence.tracks[0].presetName ||
        props.subSequence.tracks[0].getName() : NAMES[props.i];

    if (name !== undefined && name.length >= MAX_NAME_LENGTH) {
        name = name.substring(0, MAX_NAME_LENGTH);
    }

    const onVolumeChange = (v) => {
        props.subSequence.fade = v;
    };

    let nameClass = props.subSequence.isTrack ? 'sub-sequence-name is-track' : 'sub-sequence-name';
    let nameStyle = {
    };

    if (props.subSequence.isTrack && props.isSelected) {
        let track = props.subSequence.tracks[0];
        let name = track.presetName || track.getName();
        nameStyle = {
            backgroundColor: colors.getColorForHash(name)
        };
    }

    let id = typeof props.subSequence.id === "string" ?
        props.subSequence.id.slice(0, 10) :
        "s" + props.subSequence.id;
    let color = colors.saturate(colors.getColorForHash(id), 3);
    let style = {
        borderRightColor: color,
        backgroundColor: color
    };

    return (
        <div>
        <div
          onMouseDown={e => e.stopPropagation()}
          onMouseUp={e => e.stopPropagation()}
          onClick={selectRow}
          onMouseMove={stopPropagation}
          style={style}
          onDragStart={stopPropagation}
          className={className}>
          <div
            style={nameStyle}
            className={nameClass}>
            {name}
          </div>
          <div className="panel-rest">
            <div className="track-controls-container">
              <ConditionedComponent condition={props.subSequence.isTrack}>
                  <div 
                    onClick={() => toggleEnabled()}
                    className={props.isEnabled ? "midi-recording-button on" : "midi-recording-button off"}>
                    <span className="black plain-dot"></span>
                  </div>
                </ConditionedComponent>
              <TracksShowButton subSequence={props.subSequence}/>
            </div>
          </div>
        </div>
          {props.showTracks ? <TracksSidePanel style={style} subSequence={props.subSequence}/> : ''}
        </div>
    );
    
}

const mapStateToProps = (state, props) => {
    let volume = state.mix.subSequenceFades[props.subSequence.id];
    let enabledMap = state.tracks.trackIsEnabled[props.subSequence.id] || {};
    let isEnabled = enabledMap[0];

    return {
        isSelected: getIsSelected(state, props),
        volume: volume === undefined ? 1 : volume,
        muted: state.mix.subSequenceMuted[props.subSequence.id],
        isEnabled:  isEnabled === undefined ? false : isEnabled,
        showTracks: state.arrangement.showTracks[props.subSequence.id],
        numTracks: props.subSequence.tracks && props.subSequence.tracks.length
    };
};

const mapDispatchToProps = (dispatch, props) => {
    let subSequenceId = props.subSequence.id;
    return {
        setSelectedRows: p => dispatch(setArrangementSelectedRows(p)),
        setArrangementMode: (mode) => dispatch(setArrangementBottomMode(mode)),
        clearSelectedArrangementEvents: () => dispatch(setSelectedArrangementEvents(undefined)),
    };
};
 
export default connect(mapStateToProps, mapDispatchToProps)(SubSequenceSidePanel);
